
    <input type="text"
           class="inline-edit--field"
           disabled
           [ngModel]="value"
           [id]="handler.htmlId" />
  